export default {"src":"/_next/static/media/IconKymco.1fd32b83.svg","height":20,"width":36,"blurWidth":0,"blurHeight":0};